import React from 'react';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Cnt, StyledTable } from './table-styles';

export default props => {
  const { projectsToChange } = props;

  return (
    <Cnt>
      Devices will be unassigned from sub-projects
      <br />
      <StyledTable aria-label="projects will be changed">
        <TableHead>
          <TableRow>
            <TableCell>Project name</TableCell>
            <TableCell>Devices</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {projectsToChange.map(p => (
            <TableRow key={p.id}>
              <TableCell component="th" scope="row">
                {p.title}
              </TableCell>
              <TableCell>
                {p.unassignedDevices.map(device => device.label).join(', ')}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </StyledTable>
    </Cnt>
  );
};
